export const MAX_IMG_SIZE = 5120000;
export const MAX_FILE_SIZE = 5120000;
export const DEFAULT_AVATAR = "/assets/media/image/avatar.png";
export const DEFAULT_BUSINESS_LOGO = "/assets/media/image/default-profile.png";
export const WEBHOOK_EVENTS = [
                                { label: "Failed Transactions", value: "transaction_failed" },
                                { label: "Successful Transactions", value: "transaction_success" },
                                { label: "Updated Transactions", value: "transaction_updated" },
                                { label: "Completed Payouts", value: "payout_completed" },
                                { label: "Failed Payouts", value: "payout_failed" },
                                { label: "Received Payouts", value: "payout_received" },
                                { label: "Cancelled Payouts", value: "payout_cancelled" },
                                { label: "All Webhooks", value: "all" }
                            ];
export  const PAYMENT_METHODS = {
    "bank": "Customers can use their bank on Vendy to make payments",
    "card": "Customers can use their card on Vendy to make payments",
    "mobile_money": "Customers can use mobile money on Vendy to make payments",
    "transfer_pay": "Customers can link their bank accounts on Vendy to make payments",
    "vendy_connect": "Customers can link their bank accounts, wallets on Vendy to make payments",
    "vendy_direct": "A direct integration with your customers bank accounts via their phone numbers",
    "wallet": "Customers can link their wallets on Vendy to make payments",
    "payment_card": "Card payments with Mastercard, VISA, Verve e.t.c",
    "paystack_apple_pay": "Payments made easy with Apple",
    "beyonic": "Payments with Beyonic",
    "sterling": "Customers can link their Sterling bank accounts",
    "pay_wallet": "Payments with transfer to virtual account",
    "fcmb": "Customers can link their FCMB Bank accounts",
    "opay_connect": "Customers can link their Opay Bank accounts",
    "kuda_pay": "Customers can link their Kuda Bank accounts",
    "sterling_wallet": "Customers can link their Sterling bank wallets",
    "wema_wallet": "Customers can link their Wema Bank wallets"
}
